// extracted by mini-css-extract-plugin
module.exports = {"icon_cMXDOq":"icon_cMXDOq","profile-container_fMWSU8":"profile-container_fMWSU8","custom-profile_iBa2Fl":"custom-profile_iBa2Fl"};